module.exports = __webpack_public_path__ + "img/bg_pic2.0ab71e21.png";